import React from "react";
import "./StatusAvatar.css";

const FALLBACK_PIC =
  "https://cdn-icons-png.flaticon.com/512/149/149071.png";

// Reusable story-style avatar shared by Profile / ViewBlogs / AuthorProfile.
//
//  - hasStatus = false → plain avatar, no ring (still clickable if onClick set)
//  - hasStatus + hasUnviewed → animated gradient ring (Instagram/WhatsApp style)
//  - hasStatus + all viewed → muted grey ring
//
// `size` is the avatar diameter in px. `onClick` makes the avatar behave like a
// button (keyboard accessible). Everything degrades gracefully without props.
function StatusAvatar({
  src,
  alt = "",
  hasStatus = false,
  hasUnviewed = false,
  size = 48,
  onClick,
  className = "",
  title,
}) {
  const ringClass = !hasStatus
    ? "sa-ring-none"
    : hasUnviewed
    ? "sa-ring-active"
    : "sa-ring-viewed";

  const clickable = typeof onClick === "function";

  const handleKeyDown = (e) => {
    if (!clickable) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick(e);
    }
  };

  return (
    <div
      className={`sa-avatar ${ringClass} ${
        clickable ? "sa-clickable" : ""
      } ${className}`}
      style={{ width: size, height: size }}
      onClick={clickable ? onClick : undefined}
      onKeyDown={clickable ? handleKeyDown : undefined}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      title={title}
    >
      <span className="sa-ring" />
      <img
        src={src || FALLBACK_PIC}
        alt={alt}
        className="sa-img"
        onError={(e) => {
          if (e.currentTarget.src !== FALLBACK_PIC) {
            e.currentTarget.src = FALLBACK_PIC;
          }
        }}
      />
      {hasStatus && hasUnviewed && <span className="sa-dot" />}
    </div>
  );
}

export default StatusAvatar;
